import React from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';
import moment from 'moment'

const styles = StyleSheet.create({
    titleContainer:{
        flexDirection: 'row',
        marginTop: 18,
        justifyContent: 'space-between'
    },
    reportTitle:{
        marginTop:-16,
        fontSize: 32,
        textAlign: 'left'
    },
    companyTitle:{
        fontFamily:'HelveticaBold',
        textAlign:'right',
        marginBottom:-4,
    },
    paragraph:{
        textAlign:'right',
        fontSize: 8,
    }
  });


  const InvoiceTitle = ({title,invoiceNumber,period,issuedAt,dueAt}) => (
    <View style={styles.titleContainer}>
        <View style={{width: '30%',flexDirection:'column'}}>
            <Text style={styles.reportTitle}>{title}</Text>
            <View style={{flexDirection:'row',marginTop:-12}}>
                <Text style={{width:'30%'}}>Number</Text>
                <Text style={{width:'10%'}}>:</Text>
                <Text style={{width:'50%'}}>{invoiceNumber}</Text>
            </View>
            <View style={{flexDirection:'row'}}>
                <Text style={{width:'30%'}}>Period</Text>
                <Text style={{width:'10%'}}>:</Text>
                <Text style={{width:'50%'}}>{period}</Text>
            </View>
            <View style={{flexDirection:'row'}}>
                <Text style={{width:'30%'}}>Issued</Text>
                <Text style={{width:'10%'}}>:</Text>
                <Text style={{width:'50%'}}>{issuedAt}</Text>
            </View>
            <View style={{flexDirection:'row'}}>
                <Text style={{width:'30%'}}>Due Date</Text>
                <Text style={{width:'10%'}}>:</Text>
                <Text style={{width:'50%'}}>{dueAt}</Text>
            </View>
        </View>
        <View style={{width: '70%'}}>
            <Text style={styles.companyTitle}>PT BERBAGI INOVASI TEKNOLOGI</Text>
            <Text style={styles.paragraph}>Komplek Timah Fatmawati No. 12A</Text>
            <Text style={styles.paragraph}>Cilandak Barat, Cilandak, Jakarta Selatan. DKI Jakarta 12430</Text>
            <Text style={styles.paragraph}>www.biteship.com</Text>
        </View>
    </View>
  );
  
  export default InvoiceTitle